import React from 'react';

const SmallScreenWarning: React.FC = () => {
  return (
    <div className="small-screen-warning">
      <div className="warning-content">
        <h2>Screen Size Too Small</h2>
        <p>Please resize your window to enjoy the full experience of the Airplane Tracker.</p>
      </div>
    </div>
  );
};

export default SmallScreenWarning; 